import { Row } from 'react-bootstrap';
import FormTextAreaField from '../../../formFields/FormTextAreaField';

const descriptionPlaceholder = 'Enter a description...';

export const SafetyMessageField = () => (
  <Row>
    <FormTextAreaField
      title="Safety Message"
      fieldName="safetyMessage"
      placeholder={descriptionPlaceholder}
      rules={{
        maxLength: {
          value: 1000,
          message: 'Maximum length is 1000 characters',
        },
      }}
      variant="full"
    />
  </Row>
);

export const SopAndSafeWorkPracticesField = () => (
  <Row>
    <FormTextAreaField
      title="Standard Operating Procedures (SOP) and Safe Work Practices"
      fieldName="sopAndSafeWorkPractices"
      placeholder={descriptionPlaceholder}
      rules={{
        maxLength: {
          value: 1000,
          message: 'Maximum length is 1000 characters',
        },
      }}
      variant="full"
    />
  </Row>
);

export const CommentsField = () => (
  <Row>
    <FormTextAreaField
      title="Comments"
      fieldName="comments"
      placeholder={descriptionPlaceholder}
      rules={{
        maxLength: {
          value: 1000,
          message: 'Maximum length is 1000 characters',
        },
      }}
      variant="full"
    />
  </Row>
);
